import { render, staticRenderFns } from "./AccountDetail.vue?vue&type=template&id=35fe33f2&scoped=true&"
import script from "./AccountDetail.vue?vue&type=script&lang=ts&"
export * from "./AccountDetail.vue?vue&type=script&lang=ts&"
import style0 from "./AccountDetail.vue?vue&type=style&index=0&id=35fe33f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fe33f2",
  null
  
)

export default component.exports